const ReviewAttribute = ({ label, value, fullWidth = false, style = {} }) => {
  return (
    <div i2c-grid={fullWidth ? "12@md" : "6@md"} className="attributes-wrapper">
      <div className="overview-help-text review-attribute-label">{label}</div>
      <div
        className="overview-val-text review-text-adaptive review-attribute-value"
        style={style}
      >
        {value || "-"}
      </div>
    </div>
  );
};

export default ReviewAttribute;
